import { Network, CheckCircle2, XCircle } from "lucide-react";
import { AddressChip, BasisBadge, Panel } from "../trace/Primitives";
import { fmtNum, fmtPct, timeAgo } from "../../lib/trace";

const Sub = ({ title, basis, children }) => (
  <div className="rounded-lg border border-trace-line bg-trace-panel p-4">
    <div className="mb-3 flex flex-wrap items-center justify-between gap-2">
      <p className="text-sm font-medium text-white">{title}</p>
      <BasisBadge basis={basis} />
    </div>
    {children}
  </div>
);

export const WalletActivity = ({ data }) => {
  const w = data.wallets;
  const link = !data.is_demo;
  return (
    <Panel eyebrow="Wallet intelligence" title="Creator & related wallets" icon={Network} testId="wallet-intelligence-panel" className="lg:col-span-3">
      <div className="grid gap-4 lg:grid-cols-3">
        <Sub title="Creator wallet" basis="inferred">
          {w.creator ? (
            <div className="space-y-2 text-sm" data-testid="creator-wallet">
              <AddressChip address={w.creator.address} chars={6} link={link} testId="creator-address" />
              <p className="text-trace-muted">Holds <span className="font-mono text-white">{fmtNum(w.creator.balance_ui)}</span> ({fmtPct(w.creator.balance_pct)} of supply)</p>
              <p className="text-xs text-trace-dim">Creator attribution is reported by RugCheck's indexer, not read from the mint account.</p>
            </div>
          ) : <p className="text-sm text-trace-muted">Creator could not be determined.</p>}
        </Sub>
        <Sub title="Creator recent transactions" basis="confirmed">
          {w.creator_activity.length ? (
            <ul className="space-y-2" data-testid="creator-activity-list">
              {w.creator_activity.slice(0, 6).map((a) => (
                <li key={a.signature} className="flex items-center justify-between gap-2 text-xs">
                  <span className="flex items-center gap-1.5">
                    {a.status === "success" ? <CheckCircle2 size={12} className="text-trace-green" /> : <XCircle size={12} className="text-red-400" />}
                    <AddressChip address={a.signature} link={link} kind="tx" chars={6} />
                  </span>
                  <span className="font-mono text-trace-dim">{timeAgo(a.block_time)}</span>
                </li>
              ))}
            </ul>
          ) : <p className="text-sm text-trace-muted">{w.creator_activity_error ? `RPC unavailable: ${w.creator_activity_error}` : "No recent transactions found."}</p>}
        </Sub>
        <Sub title="Linked wallet clusters" basis="inferred">
          {w.insider_networks.length ? (
            <ul className="space-y-2 text-sm" data-testid="insider-networks-list">
              {w.insider_networks.slice(0, 4).map((n) => (
                <li key={n.id} className="flex items-center justify-between gap-2">
                  <span className="font-mono text-xs text-amber-300">{n.id}</span>
                  <span className="text-xs text-trace-muted">{n.size} wallets · {n.type}{n.holding_pct !== null && n.holding_pct !== undefined ? ` · ${fmtPct(n.holding_pct)}` : ""}</span>
                </li>
              ))}
            </ul>
          ) : <p className="text-sm text-trace-muted">No linked clusters reported.</p>}
          <p className="mt-3 text-xs text-trace-dim">Clusters are heuristic groupings (e.g. shared funding). They suggest, but do not prove, common control.</p>
        </Sub>
      </div>
    </Panel>
  );
};
